export const FREE_PLAN_INVOICES_LIMIT_PER_MONTH = 20;
